module.exports = __webpack_public_path__ + "static/media/category3.2cb29586.svg";